const columnsOtherData = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Prisma',
    dataIndex: 'prisma',
    key: 'prisma',
  },
  {
    title: 'Queratometría',
    dataIndex: 'queratometria',
    key: 'queratometria',
  },
  {
    title: 'Cil. Corneal',
    dataIndex: 'cilindroCorneal',
    key: 'cilindroCorneal',
  },
];
const columnsRefractometer = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
    onRow: () => {
    }
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
  },
];
const columnsOldRx = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
  },
  {
    title: 'Esf. Cerca',
    dataIndex: 'esfCerca',
    key: 'esfCerca',
  },
  {
    title: 'Adicion',
    dataIndex: 'adicion',
    key: 'adicion',
  },
  {
    title: 'Pri. Lejos',
    dataIndex: 'priLejos',
    key: 'priLejos',
  },
  {
    title: 'Pri. Cerca',
    dataIndex: 'priCerca',
    key: 'priCerca',
  },
];
const columnsSubjective = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
  },
  {
    title: 'Esf. Cerca',
    dataIndex: 'esfCerca',
    key: 'esfCerca',
  },
  {
    title: 'Adicion',
    dataIndex: 'adicion',
    key: 'adicion',
  },
  {
    title: 'AVCC',
    dataIndex: 'avcc',
    key: 'avcc',
  },
];

const columnsPrism = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Hor. Lejos',
    dataIndex: 'horLejos',
    key: 'horLejos',
  },
  {
    title: 'Ver. Lejos',
    dataIndex: 'verLejos',
    key: 'verLejos',
  },
  {
    title: 'Hor. Cerca',
    dataIndex: 'horCerca',
    key: 'horCerca',
  },
  {
    title: 'Ver. Cerca',
    dataIndex: 'verCerca',
    key: 'verCerca',
  },
];

const columnsCoverTest = [
  {
    title: 'Dist.',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Sin Correc.',
    dataIndex: 'sinCorrec',
    key: 'sinCorrec',
  },
  {
    title: 'Con Correc.',
    dataIndex: 'conCorrec',
    key: 'conCorrec',
  },
];

const columnsRetinoscopia = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
  },
];

const columnsAcomodacion = [
  {
    title:'',
    dataIndex:'fila',
    key:'fila',
    className: 'borderedColumn'
  },
  {
    title:'Acomodación',
    dataIndex:'acomodacion',
    key:'acomodacion'
  }
]

const columnsBinocularidad = [
  {
    title: '',
    dataIndex: 'cr',
    key: 'cr',
    className: 'borderedColumn',
  },
  {
    title: 'Lejos',
    dataIndex: 'lejos',
    key: 'lejos',
  },
  {
    title: 'Cerca',
    dataIndex: 'cerca',
    key: 'cerca',
    className: 'borderedColumn',
  },
  {
    title: 'Esteopsis',
    dataIndex: 'esteopsis',
    key: 'esteopsis',
    render: (value:any, row:any, index:number) => {
      const obj = {
        children: value,
        props: {} as any,
      };
      // These two are merged into above cell
      if (index === 0) {
        obj.props.rowSpan = 2;
      }
       if (index === 1) {
         obj.props.colSpan = 0;
       }
      return obj;
    },
  },
];

export { columnsOtherData, columnsRefractometer, columnsOldRx, columnsSubjective, columnsCoverTest, columnsRetinoscopia, columnsPrism, columnsBinocularidad, columnsAcomodacion }
